module.exports = __webpack_public_path__ + "static/media/williaamcox-logo.f3390bbc.png";